import { CalendarDate } from '@internationalized/date';
import { Detention } from '@rematter/frontend-lib-api-client';

import { createMutationHook } from '~/shared/providers/api';
import { parseCalendarDate, parseZonedDateTime } from '~/shared/utils/dateTime';

export const useUpdateDetentionMutation = createMutationHook(
  'transportation.detentionUpdate',
  (params: {
    id: string;
    carrierId?: string;
    locationId?: string;
    startDate?: CalendarDate;
    endDate?: CalendarDate | null;
    freeMinutes?: number;
    ratePerMinute?: string;
  }) => ({
    transportationDetentionUpdate: {
      __args: {
        id: params.id,
        input: {
          carrierId: params.carrierId,
          locationId: params.locationId,
          startDate: params.startDate?.toString(),
          endDate: params.endDate === null ? null : params.endDate?.toString(),
          freeMinutes: params.freeMinutes,
          ratePerMinute:
            params.ratePerMinute !== undefined
              ? Number(params.ratePerMinute)
              : undefined,
        },
      },
      id: true,
      carrierId: true,
      carrier: {
        id: true,
        name: true,
      },
      locationId: true,
      location: {
        id: true,
        facilityName: true,
      },
      startDate: true,
      endDate: true,
      freeMinutes: true,
      ratePerMinute: true,
      timestamps: {
        createdAt: true,
        updatedAt: true,
      },
    },
  }),
  {
    select: (data) => {
      const detention = (data as { transportationDetentionUpdate: Detention })
        .transportationDetentionUpdate;
      return {
        id: detention.id,
        carrierId: detention.carrierId,
        carrierName: detention.carrier?.name ?? undefined,
        locationId: detention.locationId,
        locationName: detention.location?.facilityName ?? undefined,
        startDate: parseCalendarDate(detention.startDate),
        endDate: detention.endDate
          ? parseCalendarDate(detention.endDate)
          : undefined,
        freeMinutes: detention.freeMinutes,
        ratePerMinute: detention.ratePerMinute,
        timestamps: {
          createdAt: parseZonedDateTime(detention.timestamps.createdAt),
          updatedAt: parseZonedDateTime(detention.timestamps.updatedAt),
        },
      };
    },
  },
);
